import Api from ".";
import { AZUREURL, DEVURL } from "./envUrl";

const headers = {
  "Content-Type": "application/json",
  "Content-Language": "en-US",
  "Access-Control-Allow-Origin": "*",
};

export const getDesignJobsData = async (projectId, payload) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  const apiURL = `${DEVURL}/postDesignJobs/${projectId}`;

  const response = await axiosInstance({
    url: apiURL,
    method: "POST",
    data: payload
  });

  return response;
};

export const triggerForceApprove = async (projectId, designJobId) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  const apiURL = `${DEVURL}/processDesignJobs/${projectId}/ForceApprove/${designJobId}`;

  const response = await axiosInstance({
    url: apiURL,
    method: "PUT"
  });

  return response;
};


export const getVersionList = async (projectId, designJobId) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  const apiURL = `${DEVURL}/getFileVersion/${projectId}/${designJobId}`;

  const response = await axiosInstance({
    url: apiURL,
    method: "GET"
  });

  return response;
};

export const getMarkUp = async (projectId, designJobId) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  const apiURL = `${DEVURL}/getMarkUp/${projectId}/${designJobId}`;

  const response = await axiosInstance({
    url: apiURL,
    method: "GET"
  });

  return response;
};

export const zipDownload = async (payload) => {
  const api = new Api();
  const axiosInstance = await api.init({
    "Content-Type": "application/json",
  });
  const apiURL = `${AZUREURL}/bulkDownloadFiles`;

  const response = await axiosInstance({
    url: apiURL,
    method: "POST",
    data: payload,
    responseType: "blob",
  });

  // Create ZIP blob
  const blob = new Blob([response.data], {
    type: "application/zip",
  });

  // Create download link
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = "designjob files.zip";
  document.body.appendChild(link);
  link.click();

  // Cleanup
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
};